<div class="form-group">
  <label class="d-block" *ngIf="label">{{ label }}</label>

  <div class="form-check form-check-inline" *ngIf="!requireDateRange">
    <input class="form-check-input" type="radio"
           [name]="idPrefix + '_mode'" [id]="idPrefix + '_mode_none'"
           [value]="Mode.none" [ngModel]="mode"
           (ngModelChange)="onModeChange($event)">
    <label class="form-check-label" [for]="idPrefix + '_mode_none'">No filter</label>
  </div>
  <div class="form-check form-check-inline">
    <input class="form-check-input" type="radio"
           [name]="idPrefix + '_mode'" [id]="idPrefix + '_mode_relative'"
           [value]="Mode.relative" [ngModel]="mode"
           (ngModelChange)="onModeChange($event)">
    <label class="form-check-label" [for]="idPrefix + '_mode_relative'">Preset period</label>
  </div>
  <div class="form-check form-check-inline">
    <input class="form-check-input" type="radio"
           [name]="idPrefix + '_mode'" [id]="idPrefix + '_mode_fixed'"
           [value]="Mode.fixed" [ngModel]="mode"
           (ngModelChange)="onModeChange($event)">
    <label class="form-check-label" [for]="idPrefix + '_mode_fixed'">Specific dates</label>
  </div>
  <div class="form-check form-check-inline" *ngIf="allowDaysAgo">
    <input class="form-check-input" type="radio"
           [name]="idPrefix + '_mode'" [id]="idPrefix + '_mode_days_ago'"
           [value]="Mode.daysAgo" [ngModel]="mode"
           (ngModelChange)="onModeChange($event)">
    <label class="form-check-label" [for]="idPrefix + '_mode_days_ago'">Days ago</label>
  </div>

  <div *ngIf="mode === Mode.relative" [ngClass]="requireDateRange ? 'mt-1' : 'mt-2'">
    <select class="custom-select" [id]="idPrefix + '_range'"
            [ngModel]="range" (ngModelChange)="setRange($event)">
      <option *ngIf="!requireDateRange" [ngValue]="undefined">Select a range…</option>
      <ng-container *ngIf="upcomingRangeOptions.length > 0; else flatRangeOptions">
        <optgroup label="Past and present">
          <option *ngFor="let option of rangeOptions" [ngValue]="option.value">
            {{ option.label }}
          </option>
        </optgroup>
        <optgroup label="Upcoming">
          <option *ngFor="let option of upcomingRangeOptions" [ngValue]="option.value">
            {{ option.label }}
          </option>
        </optgroup>
      </ng-container>
      <ng-template #flatRangeOptions>
        <option *ngFor="let option of rangeOptions" [ngValue]="option.value">
          {{ option.label }}
        </option>
      </ng-template>
    </select>
  </div>

  <!-- The min/max fixed-date pickers, wired once and reused by both fixed-mode
       layouts below. The .date-range-fixed-input flex sizing is inert inside the
       labelled .col-6 (not a flex container), so it's safe on both. -->
  <ng-template #fixedMinPicker>
    <app-date-picker class="date-range-fixed-input" [id]="idPrefix + '_min'"
                     [content]="min" [required]="requireDateRange"
                     (contentChange)="setMin($event)"></app-date-picker>
  </ng-template>
  <ng-template #fixedMaxPicker>
    <app-date-picker class="date-range-fixed-input" [id]="idPrefix + '_max'"
                     [content]="max" [required]="requireDateRange"
                     (contentChange)="setMax($event)"></app-date-picker>
  </ng-template>

  <!-- Fixed dates, inline style: one compact row with a dash between the inputs,
       so switching modes doesn't grow the height/width (Chart Builder's row 1). -->
  <div *ngIf="mode === Mode.fixed && inlineFixedRange" class="mt-1 d-flex align-items-center">
    <ng-container *ngTemplateOutlet="fixedMinPicker"></ng-container>
    <span class="mx-2">&ndash;</span>
    <ng-container *ngTemplateOutlet="fixedMaxPicker"></ng-container>
  </div>

  <!-- Fixed dates, default style: labelled "On or after" / "On or before". -->
  <div *ngIf="mode === Mode.fixed && !inlineFixedRange" class="row mx-0"
       [ngClass]="requireDateRange ? 'mt-1' : 'mt-2'">
    <div class="col-6 pl-0">
      <label [for]="idPrefix + '_min'">On or after</label>
      <ng-container *ngTemplateOutlet="fixedMinPicker"></ng-container>
    </div>
    <div class="col-6 pr-0">
      <label [for]="idPrefix + '_max'">On or before</label>
      <ng-container *ngTemplateOutlet="fixedMaxPicker"></ng-container>
    </div>
  </div>

  <ng-container *ngIf="mode === Mode.daysAgo">
    <div class="row mx-0" [ngClass]="requireDateRange ? 'mt-1' : 'mt-2'">
      <div class="col-6 pl-0">
        <label [for]="idPrefix + '_days_min'">At least</label>
        <div class="input-group">
          <input class="form-control" type="number" min="0" max="36500" step="1"
                 [id]="idPrefix + '_days_min'"
                 [ngModel]="daysMin" (ngModelChange)="setDaysMin($event)">
          <div class="input-group-append"><span class="input-group-text">days ago</span></div>
        </div>
      </div>
      <div class="col-6 pr-0">
        <label [for]="idPrefix + '_days_max'">At most</label>
        <div class="input-group">
          <input class="form-control" type="number" min="0" max="36500" step="1"
                 [id]="idPrefix + '_days_max'"
                 [ngModel]="daysMax" (ngModelChange)="setDaysMax($event)">
          <div class="input-group-append"><span class="input-group-text">days ago</span></div>
        </div>
      </div>
    </div>
    <small class="form-text text-muted">Counts calendar days in your organization's time zone; 0 is today. Records with no date are not included.</small>
  </ng-container>

  <div *ngIf="impossibleRangeWarning as warning" class="alert alert-warning py-2 mb-0 mt-3" role="alert">{{ warning }}</div>

  <!-- Optional caller-supplied help text, rendered inside this form-group. -->
  <ng-content></ng-content>

  <small class="form-text text-muted">
    <a href="https://capitan.helpscoutdocs.com/article/267-report-date-range-filters"
       target="_blank" rel="noopener noreferrer">How are these date ranges calculated?</a>
  </small>
</div>
